var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{attrs:{"gutter":20,"type":_vm.type,"align":_vm.align,"justify":_vm.justify}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }